import _ from 'lodash';
import moment from 'moment';
import { getFromTranslations } from '../translations/translations';
import { ACCOUNT_TYPE_CONSUMER, getAccountType, OfferingType } from './offeringType';

const jwtDecode = require('jwt-decode');

export const sortBillingPeriodsByLatest = (data: any) => _.sortBy(data, (period) => moment(period.startDate)).reverse();

export const sortNonActivatedSims = (list: any) => _.orderBy(list, ['mnpInfoMissing', 'needsActivation', 'simMapped'], ['asc', 'desc', 'desc']);

export const getAccountId = () => sessionStorage.getItem('accountId') || null;

export const getAccessToken = () => sessionStorage.getItem('accessToken') || null;

export const getUserId = () => sessionStorage.getItem('userId') || null;

export const isUserAuthenticated = () => getAccessToken() !== null;

export const getUIString = (accountType: string, stringKey: string) => getFromTranslations(`moi.${accountType}.${stringKey}`);

export const formatMsisdn = (msisdn: string) => {
	let temp = _.replace(msisdn, /^\+?358/, '0');
	temp = _.replace(temp, /\D/g, '');
	temp = _.replace(temp, /\\-/, '');
	const temp2 = [temp.substring(0, 3), temp.substring(3, 6), temp.substring(6, 9), temp.substring(9, 999)].join(' ');
	return _.trim(temp2);
};

export const someEndpointCallFailed = (errors: any[], endpoints: string[]) => _.some(errors, (error) => _.some(endpoints, (url) => error.endpointAndQueryParameters.includes(url))); // TODO: This should also be refactored to use RegExp

export const formatNumber = (value: number, maximumFractionDigits: number) =>
	new Intl.NumberFormat('fi-FI', {
		maximumFractionDigits
	}).format(value);

export const createClassNameList = (items: (string | undefined)[]) => {
	return items.filter((item) => item !== undefined).join(' ');
};

export const getEnumById = (id: string, instances: any[]) => {
	const result = instances.find((instance) => getEnumId(instance) === id);
	if (result !== undefined) {
		return result;
	} else {
		throw new Error('Invalid enum id: ' + id + ', expected: ' + instances.join('/'));
	}
};

export const getEnumId = (enumValue: any) => {
	return enumValue.toString();
};

export const setupSessionStorage = (accessToken: string, email: string) => {
	const accountNumber = jwtDecode(accessToken).accountNumber;
	const customerType = jwtDecode(accessToken).customerType;
	sessionStorage.setItem('accessToken', accessToken);
	sessionStorage.setItem('accountId', accountNumber);
	sessionStorage.setItem('userId', email);
	sessionStorage.setItem('customerType', customerType);
};

export const isFlutterUser = (accessToken: any, offeringType: OfferingType) => {
	if (accessToken !== null) {
		if (getAccountType(offeringType) === ACCOUNT_TYPE_CONSUMER || offeringType === OfferingType.B2B2) {
			return true;
		}
	}
	return false;
};

export const redirectToFlutter = () => {
	window.location.href = `//${window.location.hostname}/munmoi/#`;
};

export const passwordValidationRules = [
	{ key: "minLength", description: "Vähintään 12 merkkiä pitkä" },
	//{ key: "containsNumber", description: "Vöhintään yksi numero" },
	{ key: "containsUpper", description: "Vähintään yksi iso kirjain" },
	{ key: "containsSpecial", description: "Vähintään yksi erikoismerkki" }
];

export const handlePasswordValidation = (value:string) => {
	let errors: string[] = [];
	// eslint-disable-next-line no-useless-escape
		if (!/[^A-Za-z0-9]/g.test(value))
		errors = [...errors, "containsSpecial"];
	//if (!/\d/.test(value)) errors = [...errors, "containsNumber"];
	if (!/[A-Z]/.test(value)) errors = [...errors, "containsUpper"];
	if (!value.length || value?.length < 12) errors = [...errors, "minLength"];

	return errors;
};
